<template>
  <div class="advanced_set_box">
    <div class="advanced_set_content">
      <!-- <div class="advanced_set_title">{{ $t("sensor_set") }}</div> -->
      <div class="advanced_set_content_box">
        <div class="sub_content">
          <div class="debounce">
            <div class="title">{{ $t('mode_select') }}</div>
            <div class="tip_trigger" v-if="isShowAdvancedModeTip()">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
              <div class="feature_tip_bubble">{{ $t('advanced_mode_tip') }}</div>
            </div>
          </div>
          <!--  -->
          <div class="advanced_set_desc">{{ $t('mode_select_desc') }}</div>
          <div class="advanced_set_select">
            <div
              class="advanced_set_select_item"
              :class="{ active: sensorModeValue == item.value, disabled: isCordedDisabled && item.mode == 'corded' }"
              v-for="(item, index) in sensorMode"
              :key="index"
              @click="sensorModeValue != item.value && handleClick(SpecificItem.SensorMode, item.value)"
            >
              {{ $t(`sensor_${item.mode}`) }}
            </div>
          </div>
        </div>
        <div class="sub_content">
          <div class="advanced_set_sub_title">{{ $t('mode_select_lift') }}</div>
          <div class="advanced_set_desc">{{ $t('mode_select_lift_desc') }}</div>
          <div class="advanced_set_select">
            <div class="advanced_set_select_item number_width" :class="{ active: sensorLODValue == item.value }" v-for="(item, index) in sensorLOD" :key="index" @click="sensorLODValue != item.value && handleClick(SpecificItem.SensorLod, item.value)">
              {{ item.mode }}
            </div>
          </div>
        </div>
        <div class="sub_content">
          <div class="advanced_set_sub_title">
            <div>{{ $t('sensorMotionSync') }}</div>
            <cswitch class="advanced_set_switch" :width="32" :height="18" :checked="isMotionSyncEnabled" :click="enableMotionSync" />
          </div>
          <div class="advanced_set_desc advanced_set_desc_sensorMotionSync">{{ $t('sensorMotionSync_desc') }}</div>
        </div>

        <div class="sub_content" v-if="specialCheckCurrent(speciaBehiver.SupportHighPerformance)">
          <div class="advanced_set_sub_title">
            <div>{{ $t('high_performance') }}</div>
            <cswitch class="advanced_set_switch" :width="32" :height="18" :checked="isHighPerformanceEnabled" :click="enableHighPerformanceState" />
          </div>
          <div class="advanced_set_desc">{{ $t('high_performance_desc') }}</div>
          <div class="input_container">
            <input
              class="slider input_range"
              :class="{ input_range_disabled: !isHighPerformanceEnabled, disabled: !isHighPerformanceEnabled }"
              type="range"
              :min="performanceValueMin"
              :max="performanceValueMax"
              @input="inputPerformanceValueHandler"
              v-model.number="performanceValue"
              :style="{ backgroundSize: computedPerformanceInputSize }"
              @change="handleClick(SpecificItem.HighPerformance, performanceValue)"
              :disabled="!isHighPerformanceEnabled"
            />
            <div class="slider_range_value font_color" :class="{ text_disabled: !isHighPerformanceEnabled }">{{ performanceValue }}s</div>
          </div>
        </div>
      </div>
    </div>

    <div class="advanced_set_line"></div>

    <div class="advanced_set_content">
      <div class="debounce">
        <div class="title">{{ $t('debounce_title') }}</div>
        <div class="tip_trigger">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
          <div class="feature_tip_bubble">{{ $t('debounce_tip') }}</div>
        </div>
      </div>

      <div class="advanced_set_content_box">
        <div class="sub_content">
          <div class="advanced_set_desc">{{ $t('debounce_des') }}</div>
          <div class="input_container">
            <input class="slider input_range" type="range" :min="0" :max="debounceMax" step="1" v-model.number="debounceValue" :style="{ backgroundSize: computedDebounceInputSize }" @change="handleClick(SpecificItem.MouseDebounce, debounceValue)" />
            <div class="slider_range_value font_color">{{ debounceValue }}ms</div>
          </div>
        </div>
      </div>

      <div class="advanced_set_content_box">
        <!-- <debounce /> -->
        <div class="sub_content" v-if="specialCheckCurrent(speciaBehiver.SupportRippleControl)">
          <div class="advanced_set_sub_title">
            <div>{{ $t('ripple_control') }}</div>
            <cswitch class="advanced_set_switch" :width="32" :height="18" :checked="isRippleControlEnabled" :click="enableRippleControl" />
          </div>
          <div class="advanced_set_desc">{{ $t('ripple_control_des') }}</div>
        </div>
        <div class="sub_content" v-if="specialCheckCurrent(speciaBehiver.SupportLineCorrection)">
          <div class="advanced_set_sub_title">
            <div>{{ $t('line_correction') }}</div>
            <cswitch class="advanced_set_switch" :width="32" :height="18" :checked="isLineCorrectionEnabled" :click="enableLineCorrection" />
          </div>
          <div class="advanced_set_desc">{{ $t('line_correction_des') }}</div>
        </div>
        <div class="sub_content" v-if="specialCheckCurrent(speciaBehiver.SupportLongDistance)">
          <div class="advanced_set_sub_title">
            <div>{{ $t('long_distance') }}</div>
            <cswitch class="advanced_set_switch" :width="32" :height="18" :checked="isLongDistanceEnabled" :click="enableLongDistance" />
          </div>
          <div class="advanced_set_desc">{{ $t('long_distance_des') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, readonly, ref } from 'vue'
import Cswitch from '../cswitch/cswitch.vue'
import { SpecificItem } from '@libs/types/enum'
import i18n from '@/languages/i18n'
import { enableDialog } from '../cdialog/dialog'
import { setOrRead } from '@/service/driver/set_read'
import { getCurrentDevice } from '@/profiles/selector'
import { speciaBehiver, specialCheckCurrent } from '@/define/limit'
import { DeviceManager } from '@/service/device'
import { He6UltraDeviceList } from '@/define/device_vendor'
import { VirtualHe6Ultra, VirtualHe6Ultra_24g } from '@hid/define/define'
import { baseSet } from '@/service/driver/base_set'
// 0x00 lp 节能模式
// 0x01 hp 标准模式
// 0x02 corded 竞技模式
const sensorMode = ref([
  { value: 0x00, mode: 'lp' },
  { value: 0x01, mode: 'hp' },
  { value: 0x02, mode: 'corded' },
])
const sensorLOD = readonly([
  { value: 0x00, mode: '1mm' },
  { value: 0x01, mode: '2mm' },
])
const switchData = readonly([
  { value: 0x00, switch: false },
  { value: 0x01, switch: true },
])

const sensorModeValue = ref<number>()
const sensorLODValue = ref<number>()
const debounceMax = getCurrentDevice.value.debounceTime.max
const debounceValue = ref(getCurrentDevice.value.debounceTime.initValue)
const computedDebounceInputSize = computed(() => {
  const val = (debounceValue.value / debounceMax) * 100
  return `${val}%, 100%`
})

const isCordedDisabled = ref(false)
const isMotionSyncEnabled = ref(false)

const isRippleControlEnabled = ref(false)
const isLineCorrectionEnabled = ref(false)
const isLongDistanceEnabled = ref(false)
const isHighPerformanceEnabled = ref(false)

const performanceList = ref(getCurrentDevice.value.highPerformanceValues)
const performanceValue = ref(0)
const performanceValueMin = Math.min(...getCurrentDevice.value.highPerformanceValues)
const performanceValueMax = Math.max(...getCurrentDevice.value.highPerformanceValues)
const inputPerformanceValueHandler = () => (performanceValue.value = performanceFindValue(performanceList.value, performanceValue.value))
const performanceFindValue = (arr: number[], target: number): number => {
  if (arr.length === 0) return 0
  return arr.reduce((prev, curr) => {
    return Math.abs(curr - target) < Math.abs(prev - target) ? curr : prev
  })
}
const computedPerformanceInputSize = computed(() => {
  const val = (performanceValue.value / performanceValueMax) * 100
  return `${val}%, 100%`
})

const enableMotionSync = () => {
  enable(SpecificItem.SensorMotionSync, isMotionSyncEnabled.value)
}
const enableRippleControl = () => {
  enable(SpecificItem.RippleControl, isRippleControlEnabled.value)
}
const enableLineCorrection = () => {
  enable(SpecificItem.LineCorrection, isLineCorrectionEnabled.value)
}
const enableLongDistance = () => {
  enable(SpecificItem.LongDistance, isLongDistanceEnabled.value)
}
const enableHighPerformanceState = () => {
  enable(SpecificItem.HighPerformanceState, isHighPerformanceEnabled.value)
}

const enable = (item: SpecificItem, value: boolean) => {
  const foundItem = switchData.find((item) => item.switch === !value)
  if (foundItem) {
    handleClick(item, foundItem.value)
  }
}

const handleClick = async (item: SpecificItem, value: number) => {
  const { t } = i18n.global
  const check = await he6UltraSensorModeCheck()
  if (item == SpecificItem.SensorMode && check) {
    return
  }
  setOrRead.write(item, value).then(() => {
    enableDialog(t('setting_success'))
    switch (item) {
      case SpecificItem.SensorMode:
        fetchSensorMode()
        break
      case SpecificItem.SensorLod:
        fetchSensorLod()
        break
      case SpecificItem.SensorMotionSync:
        fetchSensorMotionSync()
        break
      case SpecificItem.MouseDebounce:
        fetchMouseDebounce()
        break
      case SpecificItem.RippleControl:
        fetchRippleControl()
        break
      case SpecificItem.LineCorrection:
        fetchLineCorrection()
        break
      case SpecificItem.LongDistance:
        fetchLongDistance()
        break
      case SpecificItem.HighPerformance:
        fetchHighPerformance()
        break
      case SpecificItem.HighPerformanceState:
        fetchHighPerformanceState()
        break
    }
  })
}
onMounted(() => {
  initSensorMode()

  fetchSensorMode()
  fetchSensorLod()
  fetchSensorMotionSync()
  fetchMouseDebounce()

  fetchRippleControl()
  fetchLineCorrection()
  fetchLongDistance()
  fetchHighPerformance()
  fetchHighPerformanceState()
})

const isShowAdvancedModeTip = () => {
  if (He6UltraDeviceList.includes(DeviceManager.instance.state.currentPid)) {
    return true
  }
  return false
}

const initSensorMode = async () => {
  if (He6UltraDeviceList.includes(DeviceManager.instance.state.currentPid)) {
    const check = await he6UltraSensorModeCheck()
    if (check) {
      sensorMode.value = [{ value: 0x02, mode: 'corded' }]
      isCordedDisabled.value = true
      sensorModeValue.value = 0x02
    } else {
      sensorMode.value = [
        { value: 0x00, mode: 'lp' },
        { value: 0x01, mode: 'hp' },
      ]
    }
  }
}

const he6UltraSensorModeCheck = async () => {
  const currentPid = DeviceManager.instance.state.currentPid
  await baseSet.setOrReadSpecificItemPollingRate(0)
  if (currentPid == VirtualHe6Ultra || (currentPid == VirtualHe6Ultra_24g && baseSet.state.rateValue > 1000)) {
    return true
  }
  return false
}

const fetchSensorMode = () => {
  setOrRead.read<number>(SpecificItem.SensorMode).then((res: number) => {
    const foundItem = sensorMode.value.find((item) => item.value === res)
    if (foundItem) {
      sensorModeValue.value = foundItem.value
    }
  })
}
const fetchSensorLod = () => {
  setOrRead.read<number>(SpecificItem.SensorLod).then((res: number) => {
    const foundItem = sensorLOD.find((item) => item.value === res)
    if (foundItem) {
      sensorLODValue.value = foundItem.value
    }
  })
}
const fetchSensorMotionSync = () => {
  setOrRead.read<number>(SpecificItem.SensorMotionSync).then((res: number) => {
    const foundItem = switchData.find((item) => item.value === res)
    if (foundItem) {
      isMotionSyncEnabled.value = foundItem.switch
    }
  })
}
const fetchMouseDebounce = () => {
  setOrRead.read<number>(SpecificItem.MouseDebounce).then((res: number) => {
    debounceValue.value = res
  })
}

const fetchRippleControl = () => {
  setOrRead.read<number>(SpecificItem.RippleControl).then((res: number) => {
    const foundItem = switchData.find((item) => item.value === res)
    if (foundItem) {
      isRippleControlEnabled.value = foundItem.switch
    }
  })
}

const fetchLineCorrection = () => {
  setOrRead.read<number>(SpecificItem.LineCorrection).then((res: number) => {
    const foundItem = switchData.find((item) => item.value === res)
    if (foundItem) {
      isLineCorrectionEnabled.value = foundItem.switch
    }
  })
}

const fetchLongDistance = () => {
  setOrRead.read<number>(SpecificItem.LongDistance).then((res: number) => {
    const foundItem = switchData.find((item) => item.value === res)
    if (foundItem) {
      isLongDistanceEnabled.value = foundItem.switch
    }
  })
}

const fetchHighPerformance = () => {
  setOrRead.read<number>(SpecificItem.HighPerformance).then((res: number) => {
    performanceValue.value = res
  })
}

const fetchHighPerformanceState = () => {
  setOrRead.read<number>(SpecificItem.HighPerformanceState).then((res: number) => {
    const foundItem = switchData.find((item) => item.value === res)
    if (foundItem) {
      isHighPerformanceEnabled.value = foundItem.switch
    }
  })
}
</script>

<style lang="less" scoped>
.advanced_set_box {
  position: relative;
  width: 100%;
  min-width: 0;
  min-height: 0;
  border-radius: var(--radius-l);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.12);
  padding: 30px 40px;
  display: flex;
  box-sizing: border-box;
  transition: transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  outline: none;
  background: transparent;

  /* 核心修复：使用伪元素实现毛玻璃，解决 position: fixed 弹窗被截断/位移的问题 */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--glass-panel-bg);
    backdrop-filter: var(--glass-panel-blur);
    border-radius: inherit;
    z-index: -1;
    pointer-events: none;
  }

  .advanced_set_line {
    width: 2px;
    align-self: stretch;
    background-color: #f1f1f1;
    margin-left: 40px;
    margin-right: 40px;
    margin-bottom: 0px;
    // margin-top: 30px;
  }

  .advanced_set_content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;

    .advanced_set_title {
      font-weight: bold;
      font-size: 18px;
      color: #222;
      margin-bottom: 20px;
    }

    .debounce {
      display: flex;
      cursor: pointer;
      height: 24px;
      align-items: center;
      margin-bottom: 20px;
      gap: 6px;

      .title {
        font-weight: bold;
        //font-size: 18px;
        font-size: 16px;
        color: #222;
        cursor: pointer;
        padding-left: 6px;
        border-left: var(--brand-color-pure) 4px solid;
      }

      .tip_trigger {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        color: var(--color-text-hint);
        cursor: help;
        transition: color 0.3s;

        svg {
          width: 14px;
          height: 14px;
        }

        &:hover {
          color: var(--brand-color-pure);

          .feature_tip_bubble {
            opacity: 1;
            visibility: visible;
            transform: translateY(0);
          }
        }

        .feature_tip_bubble {
          position: absolute;
          bottom: calc(100% + 10px);
          transform: translateX(-50%) translateY(10px);
          background: rgba(0, 0, 0, 0.85);
          backdrop-filter: blur(10px);
          color: #fff;
          padding: 8px 12px;
          border-radius: var(--radius-s);
          font-size: 12px;
          font-weight: normal;
          width: max-content;
          max-width: 200px;
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
          z-index: 100;
          pointer-events: none;
          text-align: left;
          line-height: 1.4;

          &:hover {
            opacity: 1;
            visibility: visible;
            transform: translateX(-50%) translateY(0);
          }

          &::after {
            content: '';
            position: absolute;
            top: 100%;
            left: 50%;
            transform: translateX(-50%);
            border: 6px solid transparent;
            border-top-color: rgba(0, 0, 0, 0.85);
          }
        }
      }
    }

    .advanced_set_content_box {
      .advanced_set_sub_title {
        font-weight: bold;
        font-size: 16px;
        color: #222;
        margin-bottom: 12px;
        display: flex;
        padding-left: 6px;
        border-left: var(--brand-color-pure) 4px solid;
      }

      .advanced_set_desc {
        font-size: 14px;
        color: #888;
        margin-bottom: 12px;
        text-wrap: wrap;
        // max-width: 452px;
      }

      .advanced_set_desc_sensorMotionSync {
        margin-bottom: 0px !important;
      }

      .advanced_set_sub_desc {
        font-size: 14px;
        color: #888;
      }

      .sub_content {
        margin-bottom: 20px;
      }

      .advanced_set_switch {
        margin-left: 12px;
        align-items: center;
        display: flex;
      }

      .advanced_set_select {
        display: flex;

        .number_width {
          min-width: 60px;
        }

        .advanced_set_select_item {
          text-align: center;
          cursor: pointer;
          margin-right: 10px;
          padding: 7px 11px;
          border-radius: var(--action-btn-radius);
          background-color: var(--glass-surface-bg);
          font-size: 14px;
          color: var(--color-text-hint);
          transition: var(--transition-base);

          &:hover {
            background-color: var(--color-white);
            color: var(--brand-color-pure);
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
          }

          &.active {
            background: var(--brand-color);
            color: #fff;
            font-weight: 600;
            box-shadow: var(--action-btn-primary-shadow);

            &:hover {
              background: var(--brand-color);
              color: #fff;
              transform: translateY(-2px);
              box-shadow: var(--action-btn-primary-shadow-hover);
            }
          }

          &.disabled {
            cursor: not-allowed;
          }
        }
      }
    }
  }
}

.input_container {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;

  .slider {
    -webkit-appearance: none;
    appearance: none;
    width: 160px;
    height: 6px;
    background-color: rgba(0, 0, 0, 0.05);
    background-image: linear-gradient(var(--brand-color-pure), var(--brand-color-pure));
    background-repeat: no-repeat;
    background-position: left center;
    border-radius: var(--radius-pill);
    border: none;
    outline: none;
    cursor: pointer;

    &.disabled {
      cursor: not-allowed;
      pointer-events: not-allowed;
    }
  }

  .slider::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    background: var(--brand-color-pure);
    border: 2px solid #fff;
    border-radius: 50%;
    box-shadow: 0 2px 6px rgba(var(--color-brand-1-rgb), 0.2);
    cursor: pointer;
    transition: var(--transition-base);

    &:hover {
      transform: scale(1.1);
    }

    &.disabled {
      cursor: not-allowed;
    }
  }

  .slider_range_value {
    margin-left: 12px;
    font-size: 14px;
    font-weight: 500;
    color: var(--brand-color-pure);
  }

  .text_disabled {
    color: var(--color-text-hint);
    opacity: 0.5;
  }
}
</style>
